// @ts-check
import { config } from "../config/config";
import { PbUtils } from "./pb-utils";

export class Utils {
/**
 * 
 * @param {any} main 
 */
constructor(main) { 
this.m = this.main = main;
this.config = config;
this.pbu = new PbUtils(null);
}//

/**
 * 
 * @param {number} length 
 * @returns 
 */
getUUID(length){
let uuid = `${crypto.randomUUID()}`;
if(length){
    uuid = uuid.substring(0,length);
}
return uuid;
//const components = [];
    
    // User agent
    //components.push(navigator.userAgent);
    
    // Screen resolution
    //components.push(`${screen.width}x${screen.height}`);
    
    // Timezone
    //components.push(Intl.DateTimeFormat().resolvedOptions().timeZone);
    
    // Language
    //components.push(navigator.language);
    
    // Canvas fingerprinting
    //components.push(await getCanvasFingerprint());
    
    // WebGL fingerprint
    //components.push(await getWebGLFingerprint());
    
    //return CryptoJS.SHA256(components.join('|')).toString();
}//

/**
 * 
 * @param {string} title 
 * @param {HTMLInputElement|null} el 
 * @returns
 */
sanitizeTitle(title,el=null){
if(el){
    title = title.replaceAll(':','-');
    el.value = title;
}else{
    title = title.replace(/[-<>:,"/\\|?*\x00-\x1F]/g, '_').replace(/\s+/g, '_');
}
return title;
}//func
/**
 * 
 * @param {any} value 
 * @param {boolean} getRawBit 
 * @returns 
 */
getBit(value,getRawBit=true){
if(getRawBit){
if(value===true||value==='true'){return 1;}
if(!value||value===false||value==='false'){return 0;}
}else{
if(value===1||value==='1'){return true;}
if(!value||value===0||value==='0'){return false;}
}

}//func

/**
 * 
 * @param {number} type 
 */
getContextualClass(type){
switch(type){
case 0:
    return 'success';
case 1:
    return 'warning';
case 2:
    return 'danger';
}
}//func

/**
 * save or return subscription cookie
 * @param {boolean} save - if true, save cookie, else check existence
 * @param {string} username
 */
genCookie(save,username){
if(save){
document.cookie = `${username}_subscribed=true; max-age=` + (365 * 24 * 60 * 60) + "; path=/";
}else{
    let subscribed = document.cookie.split('; ').find(row => row.startsWith(`${username}_subscribed`));
    return subscribed == `${username}_subscribed=true`;
}
}//

/**
 * 
 * @param {string} input 
 * @returns 
 */
capitalize(input){
if(!input){return;}
let inputToLowerCase = input.trim().toLowerCase();
let result = inputToLowerCase[0].toUpperCase();
if(input.length>1){
result += inputToLowerCase.substring(1);
}
return result;
}//

/**
 * 
 * @param {any} value 
 */
isNull(value){
    if(!value){
        return true;
    }
    if(typeof value=='undefined' || value==undefined){
        return true;
    }
    if(value=='null' || value==null){
        return true;
    }
    if(value){
        return false;
    }
}//func

/**
 * 
 * @param {any} value 
 */
isTrue(value){
if(value===true || value==='true'){
    return true;
}else{
    return false;
}
}//func

/**
 * 
 * @param {any} value 
 */
isObjectLiteral(value){
    return value !== null && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype;
}//func

/**
 * 
 * @param {any} value 
 * @param {any} defaultValue 
 * @returns 
 */
getIf(value,defaultValue){
    return (this.isNull(value))?defaultValue:value;
}//func

/**
 * 
 * @param {number} max 
 * @returns 
 */
getRandomInt(max=100) {
  return Math.floor(Math.random() * max);
}
/**
 * 
 * @param {object} o 
 * @returns 
 */
clone(o){
let serial = JSON.stringify(o);
return JSON.parse(serial);
}//   

/**
 * 
 * @param {string} fileName 
 * @param {boolean} saving - if saving to database
 */
getFileName(fileName,saving=true){
let s = this.main.config.SPLITTER;
if(saving){
    return s + fileName + s;
}else{
    return fileName.replaceAll(s,'');
}

}//func

/**
 * 
 * @param {string} title 
 * @param {any} options 
 */
async notify(title,options={}){
this.m.spin(false);
let {message='',level=1,customMessageDiv=null,fixed='top',dismiss=true,icon=''} = options;
//data integrity
if((level>=0) && (level<=2)){
level = level;
}else{
level = 1;
}
if(!icon){
    if(level==0){
        icon = 'check-circle-fill';
    }else if(level==1){
        icon = 'check-circle-fill';
    }else{
        icon = 'exclamation-triangle-fill';
    }
}
let svg = await this.main.pbu.getSvg(icon,{fill:this.main.config.ICON_FILL[level]});
if(this.main.isView){
let toastContainer = document.querySelector('.sp-toast-container');
toastContainer.innerHTML = 
`
<div id="spToast" class="toast bg-${this.getContextualClass(level)}" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header">
      <span class="sp-toast-icon">${svg}</span>
      <strong class="me-auto sp-toast-title">${title}</strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body sp-toast-body">${message}</div>
  </div>
`;
let toast = toastContainer.querySelector('#spToast');
let toastBootstrap = this.m.bootstrap.Toast.getOrCreateInstance(toast);
toastBootstrap.show();
}else{
let notificationMessageDiv = document.querySelector('#mainNotification');
if(customMessageDiv){
    notificationMessageDiv = customMessageDiv;
}
let fixedClass = (customMessageDiv)?'':`fixed-${fixed}`;
notificationMessageDiv.innerHTML = `
<div class="position-relative mt-2 p-2"> 
<div  class="${this.config.ALERT_TYPE[level]} ${fixedClass} text-center mt-2 p-2 mx-auto w-50 sp-alert alert alert-dismissible fade show role="alert">
<span class="sp-toast-icon">${svg}</span>
<strong>${title}</strong> 
<div class="toast-body sp-toast-body">${message}</div>
<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>
</div>
`;

if(dismiss){
    setTimeout(() => {
        notificationMessageDiv.innerHTML = ''
    }, 5000);
}
}
//finally
if(this.main.activeSaveButton){
this.main.activeSaveButton.disabled = false
}

}//func



/**
 * 
 * @param {string} title 
 * @param {string} message 
 */
async showToast(title,message,options={}) {
let {icon='',type=2} = options;
let color = `bg-${this.getContextualClass(type)}`;
let fill = this.main.config.ICON_FILL[type];

let toast = document.getElementById('spToast');
let toastHeader = document.querySelector('.toast-header');
let toastBootstrap = bootstrap.Toast.getOrCreateInstance(toast);
this.main.pbu.replace(document.querySelector('.sp-toast-title'),title);
this.main.pbu.replace(document.querySelector('.sp-toast-body'),message);
this.main.pbu.addClass(toast,[color]);
if(icon){
    this.main.pbu.replace(document.querySelector('.sp-toast-icon'),await this.main.pbu.getSvg(icon,{fill:fill}));
}

toastBootstrap.show();
}//inner

/**
 * 
 * @param {string} title 
 * @param {string|HTMLElement} body 
 * @param {boolean} isView
 * @param {any} options
 * @returns 
 */
setModal(title,body,isView=false,options={} ){
let{withAction=true,confirmText='OK',cb=null,clasz=[]} = options;
let div = this.main.pbu.createElement('div',['prompt-modal']);
div.innerHTML = 
`
<button id="promptModalTrigger" data-bs-toggle="modal" data-bs-target="#promptModal"></button>
<div class="modal fade" id="promptModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">${title}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <p class="modal-notice"></p>
        <div class="modal-body">

        </div>

        <div class="modal-footer">
          <span id="modalButton"></span>
        </div>
      </div>
    </div>
  </div>
  `;
//handle
let promptModalSection = document.querySelector('section#promptModalSection');//in dashboard component
let promptModalTrigger = div.querySelector('#promptModalTrigger');//<button>
let modal = div.querySelector('.modal');
let modalTitle = div.querySelector('#promptModal .modal-title');//<h5>
let modalNotice = div.querySelector('#promptModal .modal-notice');//<p> 
let modalBody = div.querySelector('#promptModal .modal-body');//<div>
let modalDismiss = div.querySelector('#promptModal .btn-close');

this.main.pbu.replace(promptModalSection,div);
modalBody.innerHTML = modalNotice.innerHTML = ''
if(body){
if(body=='blanc'){
    modalBody.innerHTML = '';
}else{
this.main.pbu.replace(modalBody,body);
}
}else{
    this.main.pbu.replace(modalBody,this.main.pbu.createFormControl({clasz:['sp-modal-input']}));
}
let input = modalBody?.querySelector('input.sp-modal-input');
if(clasz.length>0){
    this.main.pbu.addClass(modal,clasz);
}
let template = {
init:()=>{modalNotice.innerHTML = ''},
title:modalTitle,
notice:modalNotice,
body:modalBody?modalBody:null,
input:input,
dismiss:modalDismiss,
close:()=>modalDismiss.click()
};

if(withAction){
let actionDiv = this.pbu.createElement('div',['mt-2']);
modalBody.appendChild(actionDiv);
let cancelButton = this.pbu.createElement('button',['btn','btn-primary','float-start'],'Cancel');
let confirmButton = this.pbu.createElement('button',['btn','btn-primary','float-end'],confirmText);
this.pbu.appendChild(actionDiv,cancelButton,confirmButton);
template.confirm=confirmButton;
template.cancel =cancelButton,
//events
// x icon
this.pbu.listen(modalDismiss,'click',()=>{;
promptModalSection.innerHTML = '';
});
//
this.pbu.listen(cancelButton,'click',()=>{
modalDismiss.click();
});


this.pbu.listen(confirmButton,'click',()=>{;
if(cb){
cb();
//modalDismiss.click();
}else{
 //modalDismiss.click();   
}

});   

}

promptModalTrigger.click();
return template;
}//func

/**
 * 
 * @param {string} title 
 * @param {string|HTMLElement|null} body 
 * @param {any} options
 * @returns 
 */
setOffCanvas(title='',body=null,options={} ){
let{placement='start',cb=null,clasz=[]} = options;
let div = this.main.pbu.createElement('div',['prompt-modal']);
div.innerHTML = 
`
<button id="offCanvasTrigger" data-bs-toggle="offcanvas" data-bs-target="#offCanvas"></button>
<div class="offcanvas offcanvas-${placement}" tabindex="-1" id="offCanvas" aria-labelledby="offCanvas">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasLabel">${title}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <p class="offcanvas-notice"></p>
  <div class="offcanvas-body">
    
  </div>
</div>
  `;
//handle
let offCanvasSection = document.querySelector('section#offCanvasSection');//in dashboard component
let offCanvasTrigger = div.querySelector('button#offCanvasTrigger');
let offCanvas = div.querySelector('div.offcanvas');
let offCanvasTitle = div.querySelector('h5.offcanvas-title');
let offcanvasNotice = div.querySelector('p.offcanvas-notice');
let offcanvasBody = div.querySelector('div.offcanvas-body');
let offcanvasDismiss = div.querySelector('button.btn-close');

//mainly for bottom placement 
if(options.height){
    offCanvas.style.height = options.height;
}

this.m.pbu.replace(offCanvasSection,div);
if(body){
this.main.pbu.replace(offcanvasBody,body);
}

if(clasz.length>0){
    this.main.pbu.addClass(offCanvas,clasz);
}

if(cb){
this.pbu.listen(offcanvasDismiss,'click',()=>{;
cb();
});
}

let template = {
init:()=>{offCanvasTitle.innerHTML = offcanvasBody.innerHTML = offcanvasNotice.innerHTML = ''},
title:offCanvasTitle,
notice:offcanvasNotice,
body:offcanvasBody,
dismiss:offcanvasDismiss,
close:()=>offcanvasDismiss.click()
};

offCanvasTrigger.click();
return template;
}//func

/**
 * 
 * @param {string} title 
 * @param {any[]} item 
 * @returns
 */
getItemIdFromTitle(title,item){
/**@type {any|null}*/let id = null;
for(let i of item){
    if(i.title.toLowerCase()==title.toLowerCase()){
        id = i.id;
        break;
    }
}//for
return id;
}//func

/**
 * 
 * @param {string|number} id
 * @param {any[]} item 
 * @returns
 */
getItemTitleFromId(id,item){
/**@type {any|null}*/let title = null;
for(let i of item){
    if(i.id==id){
        title = i.title;
        break;
    }
}//for
return title;
}//func
/**
 * 
 * @param {string} element
 * @param {string[]} array 
 */
pop(element,array){
let i = array.indexOf(element);
if(i >-1){
array.splice(i, 1);
}
}//func

/**
 * 
 * @param {string} element 
 * @param {string[]} arr 
 */
push2(element,arr){
if(!element){return;}

element = element.trim();

if(!arr.includes(element)){
    arr.push(element);
}
}//func

/**
 * 
 * @param {string[]} elements 
 * @param {string[]} arr 
 */
push(arr,...elements){
if(!elements){return;}
for(let element of elements){
if(Array.isArray(element)){
    for(let e of element){
        e = e.trim();
if(!arr.includes(e)){
    arr.push(e);
}
}//for
}else{
element = element.trim();
if(!arr.includes(element)){
    arr.push(element);
}
}
}
}//func

/**
 * 
 * @param {any} component 
 */
finilizeSave(component){
if(this.main.activeSaveButton){
this.main.activeSaveButton.disabled = false;
}

//
}//



}//class